export type OfflineShinyRevealPreference = 'always' | 'never' | 'ask'

export const DEFAULT_OFFLINE_SHINY_REVEAL: OfflineShinyRevealPreference = 'ask'

export const OFFLINE_SHINY_REVEAL_OPTIONS: Array<{
  value: OfflineShinyRevealPreference
  labelFr: string
  labelEn: string
  descFr: string
  descEn: string
}> = [
  {
    value: 'ask',
    labelFr: 'Me demander',
    labelEn: 'Ask me each time',
    descFr: 'Choix à chaque rapport hors ligne avec shiny.',
    descEn: 'Choose on each offline report with shinies.',
  },
  {
    value: 'always',
    labelFr: 'Toujours l’animation',
    labelEn: 'Always animate',
    descFr: 'Lance automatiquement l’éclosion chromatique.',
    descEn: 'Automatically plays the shiny hatch animation.',
  },
  {
    value: 'never',
    labelFr: 'Jamais l’animation',
    labelEn: 'Never animate',
    descFr: 'Affiche directement la liste des shinies.',
    descEn: 'Shows the shiny list directly.',
  },
]

export function normalizeOfflineShinyRevealPreference(raw: unknown): OfflineShinyRevealPreference {
  if (raw === 'always' || raw === 'never' || raw === 'ask') return raw
  return DEFAULT_OFFLINE_SHINY_REVEAL
}

export function formatOfflineReportId(generatedAtMs?: number): string {
  const ms = Math.floor(Number(generatedAtMs ?? 0))
  if (ms <= 0) return '—'
  return `R-${ms}`
}
